import { useTranslation } from 'libs/i18n'
import type { Option } from 'shared/components/ContextMenu/types'
import type { FabricItem } from 'features/fabrics/types/fabrics.types'

type UseContextMenuOptionsProps = {
	onEdit: (fabric: FabricItem) => void
	onDelete: (id: number) => void
}

export const useContextMenuOptions = ({
	onEdit,
	onDelete
}: UseContextMenuOptionsProps): Option[] => {
	const { t } = useTranslation()

	return [
		{
			label: t('Edit'),
			action: (_id: number, fabric: FabricItem) => onEdit(fabric)
		},
		{
			label: t('Delete'),
			action: onDelete
		}
	]
}
